import '../scss/bootstrap.scss'

import '../scss/style.scss'

import { Tab, Collapse } from 'bootstrap'

import 'slick-carousel/slick/slick.scss'
import 'magnific-popup/src/css/main.scss'
import 'slick-carousel'
import 'magnific-popup'

import balanceText from './balanceText'

/* Custom Nav Script */
/* jQuery('.slick-custom-nav-container').on(
    'click',
    '.custom_nav-prev',
    function (event) {
        jQuery(this)
            .closest('.slick-custom-nav-container')
            .find('.slick-slider')
            .slick('slickPrev')
    }
)

jQuery('.slick-custom-nav-container').on(
    'click',
    '.custom_nav-next',
    function (event) {
        jQuery(this)
            .closest('.slick-custom-nav-container')
            .find('.slick-slider')
            .slick('slickNext')
    }
) */
/* Custom Nav Script End */

document.querySelectorAll('[data-bs-toggle="popover"]').forEach((popover) => {
    new bootstrap.Popover(popover)
})

balanceText('.balance-text')

jQuery(function ($) {
    $(window).scroll(function () {
        var scroll = $(window).scrollTop()

        if (scroll >= 100) {
            $('body').addClass('fixednav')
        } else {
            $('body').removeClass('fixednav')
        }
    })
})

jQuery(function ($) {
    if ($('.availability-date-selector').length > 0) {
        var monthNames = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ]
        var todayDate = new Date()

        var selectedDate = moment(todayDate, 'YYYY-MM-DD')
        $('.datepicker-from')
            .closest('.datepicker-wrapper ')
            .find('.availability-month')
            .text(selectedDate.format('MMM'))
        $('.datepicker-from')
            .closest('.datepicker-wrapper ')
            .find('.availability-day')
            .text(selectedDate.format('DD'))

        //var nextDay = selectedDate.add(1, 'days');
        var nextDay = selectedDate.add(2, 'days')
        $('.datepicker-to')
            .closest('.datepicker-wrapper ')
            .find('.availability-month')
            .text(nextDay.format('MMM'))
        $('.datepicker-to')
            .closest('.datepicker-wrapper ')
            .find('.availability-day')
            .text(nextDay.format('DD'))

        $('.datepicker-from').datepicker({
            dateFormat: 'yy-mm-dd',
            minDate: 0,
            onSelect: function (dateText, inst) {
                var selectedDate = moment(dateText, 'YYYY-MM-DD')
                var month = selectedDate.format('MMM')
                var day = selectedDate.format('DD')

                $('.datepicker-from')
                    .closest('.datepicker-wrapper ')
                    .find('.availability-month')
                    .text(selectedDate.format('MMM'))
                $('.datepicker-from')
                    .closest('.datepicker-wrapper ')
                    .find('.availability-day')
                    .text(selectedDate.format('DD'))

                //Get To date, to check if selected date is greater than To date
                var datepickerToVal = $('.datepicker-to').val()
                var datepickerToMoment = moment(datepickerToVal, 'YYYY-MM-DD')

                //Get Next day from selected date and set it as minimum date for To date
                var nextDay = moment(selectedDate).add(1, 'days')
                $('.datepicker-to').datepicker(
                    'option',
                    'minDate',
                    nextDay.format('YYYY-MM-DD')
                )

                //Check if selected date is greater than To date and change the To date if selected date is greater
                if (datepickerToMoment.isSameOrBefore(selectedDate, 'day')) {
                    $('.datepicker-to')
                        .closest('.datepicker-wrapper ')
                        .find('.availability-month')
                        .text(nextDay.format('MMM'))
                    $('.datepicker-to')
                        .closest('.datepicker-wrapper ')
                        .find('.availability-day')
                        .text(nextDay.format('DD'))
                }
            },
        })

        $('.datepicker-to').datepicker({
            dateFormat: 'yy-mm-dd',
            minDate: 1,
            onSelect: function (dateText, inst) {
                var selectedDate = moment(dateText, 'YYYY-MM-DD')
                var month = selectedDate.format('MMM')
                var day = selectedDate.format('DD')

                $('.datepicker-to')
                    .closest('.datepicker-wrapper ')
                    .find('.availability-month')
                    .text(selectedDate.format('MMM'))
                $('.datepicker-to')
                    .closest('.datepicker-wrapper ')
                    .find('.availability-day')
                    .text(selectedDate.format('DD'))
            },
        })

        $('.datepicker-wrapper').on('click', function () {
            $(this).find('.datepicker').datepicker('show')
        })
    }
})

/* Gallery Filters */
const gFilter_list = document.querySelectorAll('.gallery_filters__item__3LmId')
const gFilter = document.getElementsByName('filter')
const gItems = document.querySelectorAll('.gallery_media__item__8OvTu')

gFilter.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
        gFilter_list.forEach((li) => {
            li.classList.remove('active')
        })

        const filterTxt = this.previousSibling.textContent

        this.setAttribute('aria-controls', `gallery_items_${filterTxt}`)
        this.parentNode.classList.add('active')

        gItems.forEach((item) => {
            if (filterTxt === 'All') {
                item.style.display = ''
            } else {
                item.style.display = 'none'
                itemCat = item.getAttribute('aria-category')

                if (itemCat !== null && itemCat === filterTxt) {
                    item.style.display = ''
                }
            }
        })
    })
})

/* Magnific Popup*/

if (typeof jQuery !== 'undefined') {
    jQuery(function ($) {
        $('.gallery').magnificPopup({
            delegate: 'li',
            type: 'image',
            gallery: {
                enabled: true,
            },
            callbacks: {
                elementParse: function (item) {
                    item.src = item.el.find('img').attr('src')
                },
            },
        })
    })
}
